import React from 'react'
import { Link } from 'react-router-dom'
import { t } from 'i18next'
import i18n from '../i18'

// Images
import FrozenChickenLegbone from '../assets/images/products/Frozen Chicken Leg skinless.jpg'
import meat13 from '../assets/images/products/meat/lamp.jpg'
import fish from '../assets/images/products/fish.jpg'

export const Products = () => {
    const changepage = () => window.scrollTo(0, 0);
    const language = i18n.language;

    const cardData = [
        {
            id: 2,
            image: meat13,
            name: t('category.meat'),
            content: t('products.meatdetail'),
        },
        {
            id: 1,
            image: FrozenChickenLegbone,
            name: t('category.Chicken'),
            content: t('products.chickendetail'),
        },
        {
            id: 3,
            image: fish,
            name: t('category.fish'),
            content: t('products.fishdetail'),
        },
    ];

    return (
        <div id="products" className="py-20 bg-white px-4 md:px-20">

            {/* Header */}
            <div className="text-center mb-16">
                <h2 className="text-4xl md:text-5xl font-extrabold text-[#1a0080]">
                    {t('products.heading1')}
                </h2>
                <p className="mt-4 text-gray-600 max-w-lg mx-auto text-sm md:text-base">
                    {t('products.title')}
                </p>
            </div>

            {/* Product Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                {cardData.slice(0, 3).map((item, index) => (
                    <div
                        key={index}
                        className="rounded-3xl shadow-xl bg-white overflow-hidden 
                                   hover:shadow-2xl hover:-translate-y-1 
                                   transition-all duration-300 flex flex-col"
                    >
                        {/* Image */}
                        <div className="h-64 overflow-hidden relative">
                            <img
                                src={item.image}
                                alt={item.name}
                                className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                            />
                        </div>

                        {/* Text Content */}
                        <div className="p-6 flex flex-col flex-grow text-center">
                            <h3 className="text-2xl font-bold text-[#1a0080] mb-3">{item.name}</h3>

                            <p className={`text-gray-600 text-sm flex-grow leading-relaxed 
                                ${language === 'ar' || language === 'kr' ? 'text-right' : 'text-center'}`}>
                                {item.content}
                            </p>

                            {/* Button */}
                            <Link onClick={changepage} to="/product">
                                <button
                                    className="mt-6 w-full py-2 rounded-xl 
                                               bg-[#c2450b] text-white 
                                               hover:bg-[#150066] transition duration-300"
                                >
                                    {t('homePage.product.readmore')}
                                </button>
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
